import gql from 'graphql-tag';
import { graphql, compose } from 'react-apollo';

import JoinSesssionPage from './components/JoinSessionPage';

const OfficeSessionsQuery = gql`
query {
  getOfficeSessions {
    id
    start_time
    end_time
    title
    company_1
    company_2
    advisor_bio
    zoom_meeting_id
    host {
      first_name
      last_name
      photo
      biography
      advisor_info {
        advisor_summary_intro
      }
    }
  }
}
`;

const SendEmailMutation = gql`
mutation (
  $SendArray: [String]!
  $Email: String!
  $Name: String!
  $Message: String
) {
  ShareOfficeHourEmail(
    SendTo: $SendArray
    Email: $Email
    Name: $Name
    Message: $Message
  ) {
    status
  }
}
`;

export default (store) => ({
  path: 'join(/:id)',
  component:  compose(
    graphql(OfficeSessionsQuery, {
      name: 'SessionData'
    }),
    graphql(SendEmailMutation, {
      name: 'SendEmailInvite'
    })
  )(JoinSesssionPage)
});



// WEBPACK FOOTER //
// ./src/routes/officehours-v2/routes/JoinPage/index.js